import React from 'react';
import Icon from '../AppIcon';
import { useNotifications } from '@/context/NotificationContext';

const Toast = ({ toast, onRemove }) => {
  const iconMap = {
    success: { name: 'CheckCircle', color: 'text-success' },
    error: { name: 'XCircle', color: 'text-error' },
    warning: { name: 'AlertTriangle', color: 'text-warning' },
    info: { name: 'Info', color: 'text-primary' },
    message: { name: 'MessageCircle', color: 'text-accent' },
    order: { name: 'Package', color: 'text-primary' },
    bid: { name: 'Tag', color: 'text-primary' },
    event: { name: 'Calendar', color: 'text-primary' },
  };

  const icon = iconMap[toast.type] || iconMap.info;

  return (
    <div className="flex items-start gap-3 bg-card border border-border rounded-lg p-4 shadow-lg animate-slide-in-right">
      <div className={`flex-shrink-0 ${icon.color}`}>
        <Icon name={icon.name} size={20} />
      </div>
      <div className="flex-1 min-w-0">
        {toast.title && (
          <p className="font-semibold text-foreground text-sm">{toast.title}</p>
        )}
        {toast.message && (
          <p className="text-muted-foreground text-sm mt-0.5">{toast.message}</p>
        )}
        {toast.action && (
          <button
            onClick={toast.action.onClick}
            className="text-primary text-sm font-medium mt-2 hover:underline"
          >
            {toast.action.label}
          </button>
        )}
      </div>
      <button
        onClick={() => onRemove(toast.id)}
        className="flex-shrink-0 p-1 rounded hover:bg-muted transition-colors"
      >
        <Icon name="X" size={16} className="text-muted-foreground" />
      </button>
    </div>
  );
};

const ToastContainer = () => {
  const { toasts, removeToast } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-[200] flex flex-col gap-2 max-w-sm w-full pointer-events-none"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0)' }}
      role="region"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onRemove={removeToast} />
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
